module.exports = __webpack_public_path__ + "img/phone.a38fad16.svg";